/*
 *  I03PSYCHROAIRI18n.js
 *
 *  Created by Sébastien Hecart on 2018-08-02 18:39:45 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I03PSYCHROAIR_SECTION_0_TITLE: 'Données Météo',
  I03PSYCHROAIR_in_pressionAtmospherique: 'Pression atmosphérique',
  I03PSYCHROAIR_in_tempAir: "Température de l'air",
  I03PSYCHROAIR_in_humiditeRelative: 'Humidité relative',
  I03PSYCHROAIR_SECTION_1_TITLE: 'Résultats',
  I03PSYCHROAIR_res_masseVolumeAir: 'Masse volumique Air',
  I03PSYCHROAIR_res_viscDyn: 'Viscosité dynamique',
  I03PSYCHROAIR_res_viscCin: 'Viscosité cinématique',
  I03PSYCHROAIR_res_pressionVapeur: 'Pression vapeur saturante eau à température sèche',
  I03PSYCHROAIR_res_pressionPartielle: "Pression partielle de vapeur d'eau",
  I03PSYCHROAIR_res_humSpec: 'Humidité spécifique(absolue)',
  I03PSYCHROAIR_res_condThermique: 'Conductivité thermique',
  I03PSYCHROAIR_res_tempRose: 'Température de rosé',
  I03PSYCHROAIR_res_volMassique: 'Volume massique',
  I03PSYCHROAIR_res_enthAir: 'Enthalpie air',
  I03PSYCHROAIR_res_tempSaturation: 'Température de saturation adiabatique'
}
